var map = {
	"./armani": 14,
	"./armani-smartwatch": 15,
	"./armani-smartwatch.js": 15,
	"./armani.js": 14,
	"./fabricius": 16,
	"./fabricius.js": 16,
	"./getty-events": 17,
	"./getty-events.js": 17,
	"./gic": 18,
	"./gic.js": 18,
	"./hieroglyphics-initiative": 19,
	"./hieroglyphics-initiative.js": 19,
	"./imperial": 20,
	"./imperial.js": 20,
	"./john-lewis-storybook": 21,
	"./john-lewis-storybook.js": 21,
	"./mercedes-4matic": 22,
	"./mercedes-4matic.js": 22,
	"./play-with-oreo": 23,
	"./play-with-oreo.js": 23,
	"./smallfoot": 24,
	"./smallfoot.js": 24,
	"./storycastle": 25,
	"./storycastle.js": 25,
	"./the-order": 26,
	"./the-order.js": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;